export default __webpack_public_path__ + "static/initial-28656b9018d5bf061df6510168fe21e4.jpg";